import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostRecoverFile,
	PostRecoverFileModel,
	RecoverFileParams,
} from 'domain/usecases/private/authorizations';

export class RemotePostRecoverFile implements PostRecoverFile {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostRecoverFileModel>,
	) {}

	async post({signal, ...params}: RecoverFileParams): Promise<PostRecoverFileModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			body: params,
			method: 'post',
			responseType: 'json',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
